export type RateMotion = 'rise' | 'fall'

/** Presentation-only change detection; never feeds back into recorded statistics. */
export class ExpRateMotionTracker {
  private context = ''
  private baseline: number | null = null
  private pending: { direction: RateMotion; since: number } | null = null
  private nextAllowed = 0

  observe(value: number | null | undefined, now: number, context: string, running: boolean): RateMotion | null {
    if (context !== this.context || !running || value == null || !Number.isFinite(value)) {
      this.context = context
      this.baseline = running && value != null && Number.isFinite(value) ? value : null
      this.pending = null
      this.nextAllowed = 0
      return null
    }
    if (this.baseline === null || this.baseline === 0) {
      this.baseline = value
      return null
    }
    const change = (value - this.baseline) / Math.abs(this.baseline)
    if (Math.abs(change) < .25) {
      this.baseline += (value - this.baseline) * .1
      this.pending = null
      return null
    }
    const direction = change > 0 ? 'rise' : 'fall'
    if (this.pending?.direction !== direction) this.pending = { direction, since: now }
    if (now - this.pending.since < 2000 || now < this.nextAllowed) return null
    this.baseline = value
    this.pending = null
    this.nextAllowed = now + 12000
    return direction
  }
}
